import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import Component, { type MapProps } from "./component";
import { localStateSelector, makeFormIdSelector } from "./selectors";

const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();
  const formIdSelector = makeFormIdSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      apiInfo: apiInfoSelector(state, props),
      isEditMode: state.isEditMode,
      isSurveyPage: state.page.subType === "Survey",
      formId: formIdSelector(state, props),
      mustEnter: localState.mustEnter
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
